import { axiosConToken } from "../helpers/axios";
import {
  messageLoading,
  messageSuccessLoading,
  validaMessagesErrors,
  routesConfiguraciones,
} from "../helpers";
import { types } from "../types/typesNotificaciones";

export const notificacionesStartLoad = () => {
  return async (dispatch) => {
    dispatch(notificacionLoading());
    try {
      const resp = await axiosConToken.get(
        routesConfiguraciones.notificaciones,
      );
      dispatch(notificacionesLoaded(resp.data));
    } catch (error) {
      validaMessagesErrors(error);
    } finally {
      dispatch(notificacionLoading(false));
    }
  };
};
export const notificacionStartAdd = (data) => {
  return async (dispatch) => {
    const msgloading = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(
        routesConfiguraciones.notificaciones,
        data,
      );
      const { msg, notificacion } = resp.data;
      dispatch(notificacionAdded(notificacion));
      messageSuccessLoading(msgloading, msg);
    } catch (error) {
      validaMessagesErrors(error, msgloading);
    }
  };
};
export const notificacionStartUpdate = (data) => {
  return async (dispatch) => {
    const msgloading = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.put(
        `${routesConfiguraciones.notificaciones}${data.id}/`,
        data,
      );
      const { msg, notificacion } = resp.data;
      dispatch(notificacionUpdated(notificacion));
      messageSuccessLoading(msgloading, msg);
    } catch (error) {
      validaMessagesErrors(error, msgloading);
    }
  };
};
export const notificacionStartDelete = (data) => {
  return async (dispatch) => {
    const msgloading = messageLoading("Eliminando...");
    try {
      const resp = await axiosConToken.delete(
        `${routesConfiguraciones.notificaciones}${data.id}/`,
      );
      const { msg } = resp.data;
      dispatch(notificacionDeleted(data));
      messageSuccessLoading(msgloading, msg);
    } catch (error) {
      validaMessagesErrors(error, msgloading);
    }
  };
};
const notificacionesLoaded = (notificaciones) => ({
  type: types.notificacionesLoaded,
  payload: notificaciones,
});
const notificacionAdded = (notificacion) => ({
  type: types.notificacionAdded,
  payload: notificacion,
});
const notificacionUpdated = (notificacion) => ({
  type: types.notificacionUpdated,
  payload: notificacion,
});
const notificacionDeleted = (notificacion) => ({
  type: types.notificacionDeleted,
  payload: notificacion,
});
export const notificacionSetActive = (notificacion) => ({
  type: types.notificacionSetActive,
  payload: notificacion,
});
export const notificacionClearActive = () => ({
  type: types.notificacionClearActive,
});
export const notificacionLoading = (loading = true) => ({
  type: types.notificacionLoading,
  payload: loading,
});
//TODO: Implement extra functions
//ASYNC FUNCTIONS
export const get_canales_notificaciones = async () => {
  try {
    const resp = await axiosConToken.get(
      `${routesConfiguraciones.notificaciones}get_canales_notificaciones/`,
    );
    return resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
};
export const get_tipos_notificaciones = async () => {
  try {
    const resp = await axiosConToken.get(
      `${routesConfiguraciones.notificaciones}get_tipos_notificaciones/`,
    );
    return resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
};
export const get_estados_notificaciones = async () => {
  try {
    const resp = await axiosConToken.get(
      `${routesConfiguraciones.notificaciones}get_estados_notificaciones/`,
    );
    return resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
};
